import jrpc20WSClient from "./jrpc20WSClient";
import employee from "./employee";

class production{

    wsClient = new jrpc20WSClient(process.env.REACT_APP_BACKEND_WS_URL, process.env.REACT_APP_BACKEND_WS_USR, process.env.REACT_APP_BACKEND_WS_PWD)
    
    addPalletQuantity(data) {
        let employee_obj = new employee();
        return new Promise((resolve, reject) => {
            let post_data = {
                user_data: { token: employee_obj.token },
                call_data: data
            }
            this.wsClient.request('post', 'production/orderProcessing/addPalletQuantity', post_data).then((result) => {
                resolve(result.call_data);
            }).catch((error) => {
                reject(error);
            });
        });
    }
    addManualQuantity(data) {
        let employee_obj = new employee();
        return new Promise((resolve, reject) => {
            let post_data = {
                user_data: { token: employee_obj.token },
                call_data: data
            }
            this.wsClient.request('post', 'production/orderProcessing/addManualQuantity', post_data).then((result) => {
                resolve(result.call_data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    completeOrder(data) {
        let employee_obj = new employee();
        return new Promise((resolve, reject) => {
            let post_data = {
                user_data: { token: employee_obj.token },
                call_data: data
            }
            this.wsClient.request('post', 'production/orderProcessing/completeOrder', post_data).then((result) => {
                resolve(result.call_data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    confirmAutocontrollo(data) {
        let employee_obj = new employee();
        return new Promise((resolve, reject) => {
            let post_data = {
                user_data: { token: employee_obj.token },
                call_data: data
            }
            this.wsClient.request('post', 'production/orderProcessing/confirmAutocontrollo', post_data).then((result) => {
                resolve(result.call_data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

}

export default production;